import { ReactNode } from 'react'
import styled from 'styled-components'
import { useWindowSize } from 'usehooks-ts'

const Resultbar = ({
  correct,
  hideValueLabels = false,
  secondary = false,
  label,
  tertiary,
}: {
  correct: number
  hideValueLabels?: boolean
  secondary?: boolean
  tertiary?: boolean
  label?: string | ReactNode
}) => {
  const windowSize = useWindowSize()
  const isMobile = windowSize.width < 712
  const correct_percent = correct
  const wrong_percent = 100 - correct
  const minval=isMobile?15:10
  return (
    <ResultbarContainer>
      {label && <Label>{label}</Label>}
      {!hideValueLabels && (
        <BarLabels>
          {correct_percent > 0 && <Left>richtig</Left>}
          {wrong_percent > 0 && <Right>falsch</Right>}
        </BarLabels>
      )}
      <BarContainer
        style={{
          height: tertiary ? '25px' : secondary ? '40px' : '60px',
          borderRadius: tertiary ? '4px' : secondary ? '10px' : '10px',
          fontSize: tertiary ? '13px' : secondary ? '17px' : '15px',
        }}
      >
        <Correct
          style={{
            width: `${correct_percent}%`,
          }}
        >
          {correct_percent >= minval && correct_percent.toFixed(0) + '%'}
        </Correct>
        <Wrong
          style={{
            width: `${wrong_percent}%`,
          }}
        >
          {wrong_percent >= minval && wrong_percent.toFixed(0) + '%'}
        </Wrong>
        <Shadow />
      </BarContainer>
    </ResultbarContainer>
  )
}
const ResultbarContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  /* margin-bottom: 15px; */
  position: relative;
  font-family: var(--font-serif);
  margin-top: 8px;
  margin-bottom: 8px;
`

const Shadow = styled.div`
  position: absolute;
  bottom: 0;
  left: 3px;
  width: calc(100% - 6px);
  height: 20px;
  background-color: rgba(0, 0, 0, 0.1);
  background: rgb(255, 255, 255);
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 30%,
    rgba(0, 0, 0, 0.05) 65%,
    rgba(0, 0, 0, 0.15) 90%,
    rgba(0, 0, 0, 0) 100%
  );
`

export default Resultbar

const Label = styled.div`
  font-size: 18px;
  /* font-weight: bold; */
  margin-bottom: 10px;
  /* margin-top: 15px; */
  width: 100%;
  /* text-align: center; */
  /* position: absolute; */
  /* top: 0;
  left: 50%; */
  /* transform: translateX(-50%); */
  /* span {
    font-size: 18px;
  } */
  .small {
    font-family: var(--font-sans-serif);
    font-size: 15px;
    line-height: 1.2em;
    margin-bottom: 4px;
  }
  @media screen and (max-width: 711px) {
    font-size: 17px;
    line-height: 26px;
    .small {
      font-size: 12px;
      line-height: 1.2em;
    }
  }
`

const BarContainer = styled.div`
  font-family: var(--font-sans-serif);
  width: 100%;
  background-color: #ddd;
  overflow: hidden;
  /* max-width: 400px; */
  display: flex;
  font-size: 15px;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  /* margin-top: 2em; */
  -webkit-box-shadow: 0px 5px 3px 0px rgba(0, 0, 0, 0.05);
  box-shadow: 3px 3px 7px 0px rgba(0, 0, 0, 0.15);
  /* margin-bottom: 30px; */
`

const Correct = styled.div`
  height: 100%;
  background-color: var(--green-main);
  background-color: var(--correct-color);
  display: flex;
  color: var(--correct-text-color);
  justify-content: center;
  align-items: center;
  border-right: 1.5px solid var(--site-background);
  overflow: hidden;
`
const Wrong = styled.div`
  height: 100%;
  background-color: var(--wrong-color);
  /* background-color: var(--blue-bright-1);
  background-color: var(--gray-4); */

  color: var(--wrong-text-color);
  /* color:#fff; */
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`

const BarLabels = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 10px;
  /* max-width: 400px; */
  font-size: 15px;
  font-weight: 300;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
`

const Left = styled.div`
  color: var(--brandblue-bright-3);
`

const Right = styled.div`
  color: var(--brandblue-bright-3);
`
